import React from "react";
import { features } from "../../../utils/data";
import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";

const Features = () => {
  return (
    <section className="features-section py-lg-5  py-2 position-relative overflow-hidden">
      <Container>
        <Row className="g-4">
          {features.map((feature, index) => (
            <Col xs={12} md={6} lg={3} key={index}>
              <motion.div className="feature-card p-4 rounded-3 h-100 d-flex flex-column align-items-start justify-content-start"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="feature-icon mb-3">{feature.icon}</div>
                <h3 className="fs-5 fs-md-4 fs-lg-3 mb-2">{feature.title}</h3>

                <p className="mb-0 fs-6 fs-md-6 fs-lg-5">{feature.description}</p>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
